import React, { FC, ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

interface ProtectedRouteProps {
  component: ReactNode
  isAllowed: boolean
}

const ProtectedRoute: FC<ProtectedRouteProps> = ({ component, isAllowed }) => {
  return isAllowed ? component : <Navigate to="/login" />
}

export default ProtectedRoute
